'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:ui:options');
}

var _invoke = require('../invoke');

/**
 * 选项弹窗
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof ui
 * @static
 * @name options
 * @param {Array} menus 选项数组
 * @param {Object} cancel 取消按钮
 * @return {Undefined}
 * @example
 *  hbnb.ui.options([{
 *      label: 'option1',
 *      callback: function() {}
 *  }, {
 *      label: 'option2',
 *      callback: function() {}
 *  }], {
 *      label: 'cancel',
 *      callback: function() {}
 *  });
 */
module.exports = function(menus, cancel) {
    if (process.env.NODE_ENV !== 'production') {
        debug('menus is %j', menus);
        debug('cancel is %j', cancel);
    }

    _invoke('ui', 'options', {
        menus: menus,
        cancel: cancel
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/ui/options.js
// module id = 653
// module chunks = 0